import {
  LoginResult,
  UserDetails,
  LoginEnvironment
} from "@futuri/cloudsso-client/src/client//types/api";

import {
  logout,
  fetchPortalData,
  setStation,
  requestPostLoginCredential
} from "./actions";
import { Module } from "vuex";

import { SET_PORTAL_DATA, SET_STATION } from "./mutations";
import {
  POST,
  TOPIC_PULSE,
  TOPLINE,
  TETHER,
  ProductType
} from "@futuri/cloudsso-client/src/client//types/productType";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client//types/productInstances";
import { toCluster } from "@/core/api";
import { AdminUserResult } from "@futuri/cloudsso-client/src/client//types/admin";

export interface LoginModuleState {
  portalData?: LoginResult;
  station?: string;
}

export interface Cluster {
  instance?: ProductInstanceResult;
  // name: string
  // description?: string
  // product: string
  // icon?: string
  // redirectUrl?: string
  onClick?: (event: MouseEvent) => any;
  redirectUrl?: string;
}

const apiModule: Module<LoginModuleState, any> = {
  getters: {
    availableClusters(state: LoginModuleState): Cluster[] {
      const instances = state.portalData?.instances;
      const res = instances?.map(toCluster);

      return res || [];
    },

    availableInstances(state: LoginModuleState): ProductInstanceResult[] {
      const instances = state.portalData?.instances;

      return instances || [];
    },

    allUsers(state: LoginModuleState): AdminUserResult[] {
      const users = state.portalData?.users;
      return users ?? [];
    },

    environments(state: LoginModuleState): LoginEnvironment[] {
      const res = state.portalData?.environments;
      return res || [];
    },

    currentCluster(state: LoginModuleState) {
      return (product?: ProductType): Cluster | undefined => {
        const instances = state.portalData?.instances?.filter(
          inst => !product || inst.product === product
        );
        const station = state.station;

        const matching = instances?.filter(inst => inst.name === station)[0];
        if (matching) {
          return toCluster(matching);
        } else if (instances?.length) {
          return toCluster(instances[0]);
        }

        return undefined;
      };
    },

    hasUser(state: LoginModuleState): boolean {
      return !!state.portalData;
    },
    isInternalUser(state: LoginModuleState): boolean {
      return !!state.portalData?.userDetails?.isInternalUser;
    },
    isAdminUser(state: LoginModuleState): boolean {
      return !!state.portalData?.userDetails?.isAdminUser;
    },
    hasUsers(state: LoginModuleState): boolean {
      return (state?.portalData?.users?.length ?? 0) > 1;
    },

    hasPost(state: LoginModuleState): boolean {
      const keys = state.portalData?.userProductKeys;
      return keys?.indexOf(POST) !== -1;
    },
    hasTopicPulse(state: LoginModuleState): boolean {
      const keys = state.portalData?.userProductKeys;
      return keys?.indexOf(TOPIC_PULSE) !== -1;
    },
    hasTopLine(state: LoginModuleState): boolean {
      const keys = state.portalData?.userProductKeys;
      return keys?.indexOf(TOPLINE) !== -1;
    },
    hasTether(state: LoginModuleState): boolean {
      const keys = state.portalData?.userProductKeys;
      return keys?.indexOf(TETHER) !== -1;
    },

    portalData(state: LoginModuleState): LoginResult | undefined {
      return state.portalData;
    },
    user(state: LoginModuleState): UserDetails | undefined {
      return state.portalData?.userDetails;
    },
    email(state: LoginModuleState): string | undefined {
      return state.portalData?.userDetails?.email;
    }
  },

  state: {
    portalData: undefined,
    station: undefined
  },

  actions: {
    logout,
    fetchPortalData,
    setStation,
    requestPostLoginCredential
  },

  mutations: {
    SET_PORTAL_DATA,
    SET_STATION
  }
};

export default apiModule;
